import { getAllResources } from '../../../redux/store/store-helper';
import { getNestedProperty } from '@mdigital/common/dist/utils/object';

/**
 * Maps resource location paths to translation text keys for list grouping
 */
const RESOURCE_LOCATION_LIST_GROUPS = {
  'dynamicData.image': 'images',
  'triggers.0.buttonImageUrl': 'images',
  'triggers.0.desktopDesign.logoUrl': 'images',
  'settings.formThankYouPageSettings.logoURL': 'images',
  'settings.formDesignSettings.backgroundImgUrl': 'images',
  'triggers.0.desktopDesign.customCssFileResource': 'cssFiles',
  'settings.formDesignSettings.customCssFileResource': 'cssFiles',
  'customHTML.customHtmlFileResource': 'customHtmlFile',
};

/**
 * Extracts the resource URL from an object that might have nested structure
 */
function getResourceUrl(resourceObj) {
  if (!resourceObj) {return null;}
  if (typeof resourceObj === 'string') {return resourceObj;}
  if (resourceObj.url) {return resourceObj.url;}
  return null;
}

/**
 * Gets resource details (id, name, isDeployed) for a given URL
 */
function findResourceByUrl(url, allResources) {
  if (!url || !allResources) {return null;}
  return allResources.find((r) => r.url === url);
}

/**
 * Extracts all used draft resources from a form object
 * Returns an object grouped by resource type: { images: [...], cssFiles: [...], customHtmlFile: [...] }
 * Only includes resources that are not deployed
 */
export function extractUsedDraftResources(form) {
  if (!form) {return {};}

  const allResources = getAllResources() || [];
  const groupedResources = {};
  const seenIds = {};

  // Helper to add resource if it exists and is not deployed
  const addResource = (url, locationKey) => {
    const details = findResourceByUrl(url, allResources);
    if (details && !details.isDeployed && !seenIds[details.id]) {
      const listGroup = RESOURCE_LOCATION_LIST_GROUPS[locationKey] || locationKey;
      if (!groupedResources[listGroup]) {
        groupedResources[listGroup] = [];
      }
      groupedResources[listGroup].push(details);
      seenIds[details.id] = true;
    }
  };

  // Handle dynamic data images (requires nested iteration)
  const pages = form.pages || [];
  pages.forEach((page) => {
    const dynamicData = page.dynamicData || [];
    dynamicData.forEach((field) => {
      if (field.component === 'image') {
        const imageUrl = getResourceUrl(field.image_url);
        if (imageUrl) {
          addResource(imageUrl, 'dynamicData.image');
        }
      }
    });
  });

  // Check each resource path from RESOURCE_LOCATION_LIST_GROUPS (except dynamicData which needs special handling)
  Object.keys(RESOURCE_LOCATION_LIST_GROUPS)
    .filter((path) => path !== 'dynamicData.image')
    .forEach((path) => {
      const resourceUrl = getResourceUrl(getNestedProperty(form, path));
      if (resourceUrl) {
        addResource(resourceUrl, path);
      }
    });

  return groupedResources;
}
